import React, { useEffect, useState } from 'react';
import './ImgTitle.css';

const ImgTitle = ({ desktopImage, mobileImage }) => {
  const [backgroundImage, setBackgroundImage] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setBackgroundImage(window.innerWidth <= 767 ? mobileImage : desktopImage);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [desktopImage, mobileImage]);

  return (
    <div className="img-title-container">
      <div
        className="img-title-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
    </div>
  );
};

export default ImgTitle;
